document.querySelectorAll('[data-legal-toc]').forEach((toc) => {
  const article = document.querySelector('[data-legal-article]');
  const headings = article ? article.querySelectorAll('h2') : [];
  if (!headings.length) {
    toc.hidden = true;
    return;
  }

  headings.forEach((heading, index) => {
    if (!heading.id) {
      const slug = heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      heading.id = slug || `section-${index}`;
    }
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = `${index + 1}. ${heading.textContent}`;
    link.dataset.tocLink = heading.id;
    toc.appendChild(link);
  });

  const links = toc.querySelectorAll('[data-toc-link]');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        links.forEach((link) => link.classList.remove('is-active'));
        toc.querySelector(`[data-toc-link="${entry.target.id}"]`)?.classList.add('is-active');
      });
    },
    { rootMargin: '-20% 0px -70% 0px' }
  );
  headings.forEach((heading) => observer.observe(heading));
});
